"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkLoyaltyDialogResultAndAddToBasketHandler = checkLoyaltyDialogResultAndAddToBasketHandler;
var AddToBasket = _interopRequireWildcard(require("@ori-events/add-to-basket"));
var LoyaltyDialogResult = _interopRequireWildcard(require("@ori-events/loyalty-dialog-result"));
var _types = require("../types");
var _utils = require("../utils");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
async function checkLoyaltyDialogResultAndAddToBasketHandler({
  detail
}) {
  const {
    result
  } = detail;
  if (LoyaltyDialogResult.isLoyaltyCloseResult(result)) {
    return false;
  }
  if (LoyaltyDialogResult.isLoyaltyBuyForPointsResult(result)) {
    const {
      catalogueItemId,
      choiceId,
      itemCode,
      quantity,
      placement
    } = detail;
    return (0, _utils.addToBasket)(_types.RequestUrl.AddToBasketForPoints, {
      itemCode,
      quantity,
      choiceId,
      catalogueItemId,
      placement
    }, AddToBasket.Method.BUY_FOR_POINTS);
  }
  if (LoyaltyDialogResult.isLoyaltyBuyForMoneyResult(result)) {
    const {
      itemCode,
      quantity,
      originalItemCode,
      replacementType,
      placement
    } = detail;
    return (0, _utils.addToBasket)(_types.RequestUrl.AddToBasketForMoney, {
      itemCode,
      quantity,
      originalItemCode,
      replacementType,
      placement
    }, AddToBasket.Method.BUY_FOR_MONEY);
  }
  return false;
}